<template>
  <div class="product__option product__option-new-ui">
    <h2>Customize your gift</h2>

    <div class="product-form__variants"></div>
    <div id="leversphere-options">
      <div
        class="step-item first-step"
        :class="{ 'step-item--open': step1Open }"
      >
        <div class="step-header" @click="step1Open = !step1Open">
          <div class="step-header__title">
            <div class="step-header__icon step-header__icon--orange">
              <svg
                width="45"
                height="45"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h2>ADD YOUR IMAGE</h2>
          </div>
          <div class="step-header__toggle">
            <svg
              width="20"
              height="11"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7 7L13 1"
                stroke="currentColor"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <transition name="collapse">
          <div v-show="step1Open" class="step-body">
            <div
              v-if="optionsConfig.length > 0"
              class="leversphere-options-wrapper"
            >
              <SibFormItem
                v-for="opt in optionsConfig.filter(
                  (o) => !(o.type === 'TextArea' && showTextAreaAtStep2)
                )"
                :key="opt.name"
                :label="opt.label"
                :labelAsterisk="opt.required"
              >
                <!-- Loại InputText (văn bản một dòng) -->
                <Input
                  v-if="opt.type === 'InputText'"
                  :modelValue="personalizationValues[opt.name] || ''"
                  @update:modelValue="(val: string) => onOptionInput(opt.name, val)"
                  :placeholder="opt.placeholder || ''"
                  :maxlength="opt.maxLength || undefined"
                  :attributeKey="opt.name"
                />

                <!-- Loại TextArea (văn bản nhiều dòng) -->
                <textarea
                  v-else-if="opt.type === 'TextArea'"
                  :value="personalizationValues[opt.name] || ''"
                  @input="(e) => onOptionInput(opt.name, (e.target as HTMLTextAreaElement).value)"
                  :placeholder="opt.placeholder || ''"
                  :rows="opt.rows || 3"
                  class="input-field-v2 textarea-field"
                  :name="`properties[${opt.name}]`"
                ></textarea>

                <!-- Loại Dropdown (danh sách chọn) -->
                <select
                  v-else-if="opt.type === 'Dropdown'"
                  :multiple="opt.multiple"
                  @change="(e) => onDropdownChange(e, opt)"
                  class="input-field-v2 dropdown-field"
                  :name="`properties[${opt.name}]${opt.multiple ? '[]' : ''}`"
                >
                  <option v-if="!opt.multiple" value="" disabled :selected="!personalizationValues[opt.name]">{{ opt.placeholder || 'Select an option' }}</option>
                  <option
                    v-for="choice in opt.options || []"
                    :key="choice.value"
                    :value="choice.value"
                    :selected="isDropdownOptionSelected(opt, choice.value)"
                  >
                    {{ choice.label }}
                  </option>
                </select>

                <div
                  v-if="validationErrors[opt.name]"
                  class="customization-upload-image-wrapper-message text-secondary mt-xs"
                  style="color: red !important; font-weight: 500; margin-top: 4px;"
                >
                  {{ validationErrors[opt.name] }}
                </div>

                <!-- Loại MediaUploader (tải ảnh lên) -->
                <div
                  v-else-if="opt.type === 'MediaUploader'"
                  class="custom-upload-image-style-transfer"
                >
                  <div
                    v-if="!personalizationValues[opt.name] && !loadingAI"
                    class="customization-style-transfer-upload-image-button-wrap"
                  >
                    <FileUpload
                      :id="'leversphere-upload-' + opt.name"
                      text="Choose from Library"
                      :loading="loadingAI"
                      :accept="
                        opt.mediaType?.join(',') || 'image/png,image/jpeg'
                      "
                      @change="(event: Event) => onImageUploadChange(event, opt.name)"
                    />
                  </div>
                  <div
                    v-else
                    class="custom-upload-card"
                    :class="{
                      'is-complete':
                        personalizationValues[opt.name] && !loadingAI,
                    }"
                  >
                    <div class="custom-upload-card__thumb">
                      <div class="thumb-container">
                        <img
                          v-if="personalizationValues[opt.name]"
                          :src="personalizationValues[opt.name]"
                          alt=""
                        />
                        <div v-else class="thumb-placeholder">
                          <svg
                            width="65"
                            height="65"
                            viewBox="0 0 65 65"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="65"
                              height="65"
                              rx="16"
                              fill="#F3EBE1"
                            />
                            <rect
                              x="25"
                              y="24"
                              width="15"
                              height="19"
                              rx="1"
                              stroke="#D1CEC9"
                              stroke-width="1.5"
                            />
                            <circle cx="29" cy="28" r="1.5" fill="#D1CEC9" />
                            <path
                              d="M25 38L30 33L35 38L38 35L40 37"
                              stroke="#D1CEC9"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="custom-upload-card__info">
                      <div class="status-text">
                        {{
                          loadingAI
                            ? `Uploading ... ${uploadProgress}%`
                            : 'Looking good!'
                        }}
                      </div>
                      <div v-if="!loadingAI" class="filename-text">
                        {{ uploadedFileName }}
                      </div>
                      <div v-if="loadingAI" class="progress-bar">
                        <div
                          class="progress-fill"
                          :style="{ width: uploadProgress + '%' }"
                        ></div>
                      </div>
                    </div>
                    <div
                      v-if="personalizationValues[opt.name] && !loadingAI"
                      class="delete-action"
                      @click="removeUploadedImage(opt.name)"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.27 2H14.73V4H9.27V2Z" fill="#9CA3AF" />
                        <path d="M2.91 4H21.09V6H2.91V4Z" fill="#9CA3AF" />
                        <path d="M4.73 6H6.55V20H4.73V6Z" fill="#9CA3AF" />
                        <path d="M17.45 6H19.27V20H17.45V6Z" fill="#9CA3AF" />
                        <path d="M8.36 8H10.18V18H8.36V8Z" fill="#9CA3AF" />
                        <path d="M13.82 8H15.64V18H13.82V8Z" fill="#9CA3AF" />
                        <path d="M4.73 20H19.27V22H4.73V20Z" fill="#9CA3AF" />
                      </svg>
                    </div>
                  </div>
                </div>
              </SibFormItem>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div
      class="step-item leversphere-review-step"
      :class="{
        'step-item--open': step2Open,
        'has-no-step3': !showGreetingCardExtra,
      }"
    >
      <div class="step-header" @click="step2Open = !step2Open">
        <div class="step-header__title">
          <div class="step-header__icon">
            <svg
              width="45"
              height="45"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h2>REVIEW ARTWORK</h2>
        </div>
        <div class="step-header__toggle">
          <svg
            width="20"
            height="11"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <transition name="collapse">
        <div v-show="step2Open" class="step-body">
          <div class="artwork-preview">
            <div class="artwork-preview__box checkerboard">
              <img
                v-if="currentArtworkPreview"
                :src="currentArtworkPreview"
                alt=""
              />
              <div v-else class="artwork-preview__empty"></div>
            </div>
            <button
              class="btn btn--secondary btn--full"
              @click="showPreviewPopup"
              type="button"
            >
              VIEW FULL-SCREEN
            </button>

            <div
              v-if="filteredHistory.length"
              style="margin-top: 12px; width: 100%"
            >
              <ProductGreetingCardExtra3
                ref="historyCardRef"
                title="Your previous photos"
                :customItems="filteredHistory"
                :selectedIndex="aiStyleTransferRecentlyIndexSelected"
                @item-selected="
                  (data) => chooseImageAiStyleTransferRecently(data.index)
                "
              />
            </div>

            <div
              v-if="showTextAreaAtStep2"
              v-for="opt in optionsConfig.filter((o) => o.type === 'TextArea')"
              :key="opt.name"
              class="nested-step"
              :class="{ 'nested-step--open': anyChangesOpen }"
            >
              <div
                class="nested-step__header"
                @click="anyChangesOpen = !anyChangesOpen"
              >
                <span>{{ opt.label }}</span>
                <div class="nested-step__toggle">
                  <svg
                    width="20"
                    height="11"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L13 1"
                      stroke="currentColor"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <transition name="collapse">
                <div v-show="anyChangesOpen" class="nested-step__body">
                  <div class="form-group">
                    <label class="label-v3 lv2">{{
                      opt.placeholder || opt.label
                    }}</label>
                    <textarea
                      :id="'leversphere-' + opt.name"
                      :name="`properties[${opt.name}]`"
                      :value="personalizationValues[opt.name] || ''"
                      @input="(e) => onOptionInput(opt.name, (e.target as HTMLTextAreaElement).value)"
                      :rows="opt.rows || 3"
                      class="input-field-v2 textarea-field"
                    ></textarea>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <ProductUpsellV2 />

    <!-- Xem trước / Các thao tác Canvas (Chỉ có ở Chế độ Tiêu chuẩn) -->
    <div class="customily-preview">
      <sib-button
        @click="showPreviewPopup"
        type="button"
        role="primary"
        class="button-show-preview mr-sm mb-sm"
        ref="buttonShowPreview"
      >
        Preview Your Personalization
      </sib-button>

      <LightBoxPopup
        group="popup-preview"
        :contentId="popupID"
        @close="closePreviewPopup"
        ref="previewPopup"
      >
        <div
          class="product-popup-review__canvas-wrapper"
          ref="popupCanvasWrapper"
        >
          <div class="product-popup-review__note">
            <p>Please check the preview carefully</p>
            <p>
              <em
                >Make sure the below customization is correct to receive your
                item faster</em
              >
            </p>
          </div>
          <div class="panzoom__viewport"></div>
          <div class="product-popup-review__button-wrapper my-md mx-md">
            <sib-button role="primary" @click="clickAddToCartOnPreview">
              Add To Cart
            </sib-button>
          </div>
        </div>
      </LightBoxPopup>
    </div>
  </div>
</template>

<script setup lang="ts">
interface TextLayerOptions {
  left: number
  top: number
  width?: number
  fontSize?: number
  fontFamily?: string
  fontWeight?: string
  fill?: string
  originX?: string
  originY?: string
  textAlign?: string
  angle?: number
  opacity?: number
}

interface ImageLayerOptions {
  left: number
  top: number
  width: number
  height: number
  angle?: number
  opacity?: number
}


import { ref, computed, watch, onUnmounted, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { fabric } from 'fabric'
import type { Panzoom as PanzoomType } from '@fancyapps/ui'
import { mapRawMetadataToCustomizerSchema } from '@/utils/customizationMapper'
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import useCustomizationStore from '@/store/customization'
import Input from '@/ui-kits/Input.vue'
import SibFormItem from '@/ui-kits/FormItem.vue'
import LightBoxPopup from '@/ui-kits/LightBoxPopup.vue'
import FileUpload from '@/ui-kits/FileSelect.vue'
import ProductUpsellV2 from './ProductUpsellV2.vue'
import ProductGreetingCardExtra3 from './ProductGreetingCardExtraV2.vue'
import EventBus from '@/services/eventbus'
import Analytics from '@/services/analytics'
import CacheService, { getJSONfromCacheResponse } from '@/services/cache'
import {
  getRawIdFromShopifyId,
  isProductHasTags,
} from '@/utils/product'
import { cloneDeep } from '@/utils'
import {
  CUSTOMILY_CANVAS_WRAPPER_CLASS,
  CUSTOMILY_PREVIEW_CANVAS_ID,
  CUSTOMILY_CANVAS_CONTAINER_CLASS,
  EVENT_PRODUCT_UPDATE_MAIN_SLIDER,
  PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID,
  PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS,
  QUERY_STRING_NO_CACHE,
  SEVEN_DAYS_IN_MILLISECONDS,
  EVENT_PRODUCT_SHOW_PREVIEW,
  EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW,
} from '@/utils'

const emit = defineEmits<{
  (e: 'add-to-cart'): void
}>()

const route = useRoute()
const productStore = useProductStore()
const settingStore = useSettingStore()
const customizationStore = useCustomizationStore()

// Cấu hình mẫu sản phẩm (template config) từ product store
const templateConfig = computed(() => productStore.productTemplateConfig)

// Phục vụ việc map dữ liệu từ backend sang schema đồng nhất ở frontend
const customizerSchema = computed(() => {
  if (!productStore.productTemplateConfig) return null
  return mapRawMetadataToCustomizerSchema(productStore.productTemplateConfig, productStore.product)
})

// Lưu trữ giá trị cá nhân hóa do người dùng nhập hoặc tải lên (key là tên thuộc tính, value là giá trị)
const personalizationValues = ref<Record<string, string>>({})
const validationErrors = ref<Record<string, string>>({})

// DOM element tham chiếu đến vùng bao bọc canvas trong popup xem trước
const popupCanvasWrapper = ref<HTMLDivElement | null>(null)

// Tham chiếu tới instance của component LightBoxPopup dùng để xem trước toàn màn hình
const previewPopup = ref<InstanceType<typeof LightBoxPopup> | null>(null)

// Trạng thái đóng/mở của Bước 1 (ADD YOUR IMAGE)
const step1Open = ref(true)

// Trạng thái đóng/mở của Bước 2 (REVIEW ARTWORK)
const step2Open = ref(false)

// Trạng thái đóng/mở của mục chỉnh sửa văn bản lồng nhau (TextArea) ở Bước 2
const anyChangesOpen = ref(false)

// URL base64 của ảnh canvas chế độ tiêu chuẩn sau khi được render
const standardPreviewImage = ref('')

// Đối tượng FabricJS Canvas dùng để dựng hình ảnh và chữ cá nhân hóa lên ảnh nền sản phẩm
let fabricCanvas: fabric.Canvas | null = null

// Class Panzoom được import động từ thư viện @fancyapps/ui để hỗ trợ thu phóng ảnh xem trước
let Panzoom: typeof PanzoomType | null = null

// Đối tượng instance sau khi khởi tạo Panzoom
let panzoomInstance: PanzoomType | null = null

// ID định danh của popup xem trước tác phẩm cá nhân hóa
const popupID = 'product-popup-review'

// Đường dẫn ảnh preview hiện tại (ưu tiên từ store preview, nếu không có sẽ lấy từ canvas tiêu chuẩn)
const currentArtworkPreview = computed(() => {
  return productStore.productPreviewImage || standardPreviewImage.value
})

// Mã template ID của tập tùy chọn được lấy từ customizer schema
const templateCode = computed(() => {
  return customizerSchema.value?.defaultTemplateId || ''
})

// Các tuỳ chọn của form được lấy từ customizer schema (được sắp xếp theo sortOrder)
const optionsConfig = computed(() => {
  if (!customizerSchema.value?.options) return []
  return [...customizerSchema.value.options].sort(
    (a, b) => a.sortOrder - b.sortOrder
  )
})

// Xác định có hiển thị ô nhập văn bản (TextArea) ở bước 2 hay không dựa trên các quy tắc cấu hình (rules)
const showTextAreaAtStep2 = computed(() => {
  const options = customizerSchema.value?.options
  if (!options) return false
  return options.some((option) => option.type === 'TextArea')
})

// Danh sách các tùy chọn thuộc loại tải ảnh lên (MediaUploader)
const mediaUploaderOptions = computed(() => {
  return optionsConfig.value.filter((opt) => opt.type === 'MediaUploader')
})

// --- Cấu hình và Trạng thái của chế độ AI Style Transfer ---

// Xác định sản phẩm có thuộc chế độ AI Style Transfer (chuyển đổi ảnh bằng AI) hay không dựa trên tags
const isStyleTransferMode = computed(() => {
  const styleTransferTag = settingStore.shop?.productStyleTransferTag || ''
  const hasTag = isProductHasTags(productStore.product, [styleTransferTag])

  return hasTag
})

// Danh sách thiệp chúc mừng đi kèm được cấu hình cho sản phẩm này
const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return []
  }
  return settingStore.baseProductPage?.upsellGreetingCard.filter(
    (item: { tag?: string }) =>
      isProductHasTags(productStore.product, [item?.tag || ''])
  )
})

// Trạng thái hiển thị phần chọn thiệp chúc mừng đi kèm (Bước 3) nếu sản phẩm có tag thiệp chúc mừng
const showGreetingCardExtra = computed(() => {
  return greetingCardExtras.value?.length > 0
})

// Cấu hình chi tiết các template phục vụ cho việc cá nhân hóa (đã chuyển sang customizerSchema)
// const customizationTemplate = ref<StyleTransferConfig | null>(null)

// ID của template AI đang được người dùng chọn
const templateIdSelected = ref('')

watch(
  () => customizerSchema.value,
  (newSchema) => {
    if (newSchema && !templateIdSelected.value) {
      templateIdSelected.value = newSchema.defaultTemplateId
    }
  },
  { immediate: true }
)



// URL ảnh gốc của người dùng sau khi tải lên thành công hệ thống
const imageUploadUrl = ref('')

// URL ảnh kết quả cuối cùng sau khi chạy qua bộ xử lý AI style transfer thành công
const imageUrlOutput = ref('')

// Trạng thái đang tải / xử lý ảnh AI
const loadingAI = ref(false)

// Trạng thái xử lý ảnh AI thành công
const isSuccessUploadAI = ref(false)

// Tiến độ phần trăm tải ảnh lên (từ 0 đến 100)
const uploadProgress = ref(0)

// Tên file ảnh gốc đã chọn tải lên
const uploadedFileName = ref('')

// Lịch sử các ảnh AI đã được tạo gần đây của sản phẩm này (được lưu ở Cache)
const aiStyleTransferRecently = ref<
  Array<{
    image: string
    createdAt: number
    imageUploadUrl: string
    option_sort_id: string
  }>
>([])

// Chỉ số (index) của ảnh trong lịch sử đang được chọn để áp dụng lại
const aiStyleTransferRecentlyIndexSelected = ref(-1)

// Tiền tố cache giới hạn số lần chuyển đổi phong cách AI trong ngày
const AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX = 'AI-style-transfer-limited'

// Tiền tố cache lưu lịch sử ảnh AI đã tạo gần đây của sản phẩm
const AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX = 'AI-style-transfer-recently'

// Style hiện đang hoạt động dựa trên templateIdSelected
const activeStyle = computed(() => {
  if (!customizerSchema.value?.styles) return null
  return (
    customizerSchema.value.styles.find((s) =>
      s.templates.some((t) => t.id === templateIdSelected.value)
    ) || customizerSchema.value.styles[0]
  )
})

// Template hiện đang hoạt động dựa trên templateIdSelected (đã chuyển sang customizerSchema)
const activeTemplate = computed(() => {
  if (!activeStyle.value) return null
  return (
    activeStyle.value.templates.find(
      (t) => t.id === templateIdSelected.value
    ) || activeStyle.value.templates[0]
  )
})

// Lịch sử ảnh AI được lọc riêng cho activeTemplate hiện tại dựa trên option_sort_id
const filteredHistory = computed(() => {
  if (!aiStyleTransferRecently.value) return []
  const sortId = activeTemplate.value?.id || ''
  return aiStyleTransferRecently.value.filter(
    (item) => item.option_sort_id === String(sortId)
  )
})

// Các hàm của Customizer Tiêu chuẩn
/**
 * Dọn dẹp Fabric canvas, giải phóng bộ nhớ, xóa wrapper và reset dữ liệu preview trong store.
 */
function cleanupCanvas() {
  try {
    if (fabricCanvas) {
      try {
        fabricCanvas.dispose()
      } catch (e) {
        console.error('Error disposing canvas:', e)
      }
      fabricCanvas = null
    }
    const existingWrapper = document.querySelector(
      `.${CUSTOMILY_CANVAS_WRAPPER_CLASS}`
    )
    if (existingWrapper) {
      existingWrapper.remove()
    }
    standardPreviewImage.value = ''
    productStore.productPreviewImage = null
    productStore.hasPreview = false
    const productPreviewSlide = document.getElementById(
      PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID
    )
    if (productPreviewSlide) {
      productPreviewSlide.classList.remove(
        PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS
      )
    }
  } catch (error) {}
}

const debounceMap = new Map<string, ReturnType<typeof setTimeout>>()

function debounceTextInputTrack(optionName: string, value: string, label: string) {
  const key = optionName

  if (debounceMap.has(key)) clearTimeout(debounceMap.get(key))

  debounceMap.set(
    key,
    setTimeout(() => {
      if (!value) return

      Analytics.track('Input product page', {
        value: value,
        input_title: label,
        product_title: productStore?.product?.title,
        product_tags: productStore?.product?.tags,
        product_url: window.location.href,
      })

      debounceMap.delete(key)
    }, 800)
  )
}

/**
 * Xử lý khi người dùng nhập text (InputText/TextArea).
 * Cập nhật giá trị tương ứng, vẽ đè lên canvas Fabric và làm mới ảnh xem trước.
 */
function onOptionInput(optName: string, val: string) {
  try {
    personalizationValues.value[optName] = val
    if (validationErrors.value[optName] && val?.trim()) {
      delete validationErrors.value[optName]
    }

    const opt = optionsConfig.value.find(o => o.name === optName)
    if (opt) {
      debounceTextInputTrack(optName, val, opt.label)
    }

    if (fabricCanvas) {
      const layer = activeTemplate.value?.layers?.find(
        (l) => l.linkedOptionId === optName
      )
      const targetId = layer?.id

      const textObj = fabricCanvas
        .getObjects()
        .find(
          (obj: fabric.Object & { frameId?: string }) => obj.frameId === targetId
        )
      if (textObj) {
        ;(textObj as fabric.Text).set('text', val)
        fabricCanvas.renderAll()
        updateStandardPreviewImage()
        productStore.hasPreview = true
        EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)
      }
    }
  } catch (error) {}
}

/**
 * Kiểm tra option value hiện có đang được chọn trong Dropdown hay không (hỗ trợ cả single và multiple).
 */
function isDropdownOptionSelected(opt: { name: string; multiple?: boolean }, value: string): boolean {
  const current = personalizationValues.value[opt.name] || ''
  if (!opt.multiple) return current === value
  return current.split(',').filter(Boolean).includes(value)
}

/**
 * Xử lý khi người dùng chọn Dropdown (single hoặc multiple), gộp giá trị multiple thành chuỗi phân cách bằng dấu phẩy.
 */
function onDropdownChange(e: Event, opt: { name: string; multiple?: boolean }) {
  const select = e.target as HTMLSelectElement
  if (opt.multiple) {
    const values = Array.from(select.selectedOptions).map((o) => o.value)
    onOptionInput(opt.name, values.join(','))
  } else {
    onOptionInput(opt.name, select.value)
  }
}

/**
 * Gọi API chuyển đổi phong cách ảnh bằng AI (Style Transfer).
 * Chờ ảnh kết quả sẵn sàng thông qua cơ chế polling.
 */
async function triggerAiStyleTransfer(
  uploadedUrl: string,
  promptCustom: Record<string, string>,
  inputDetails: Record<string, string>
): Promise<string> {
  try {
    const dbTemplateId = activeStyle.value?.id || 0

    const productVariants: Record<string, string> = {}
    productStore.selectedVariant?.selectedOptions?.forEach((opt) => {
      productVariants[opt.name] = opt.value
    })
    const mergedOptions = {
      '_input-details': Object.keys(inputDetails).length
        ? JSON.stringify(inputDetails)
        : '',
      ...productVariants,
    }

    const transferPayload = {
      image: uploadedUrl,
      templateId: '9999',
      id: templateIdSelected.value,
      custom_name: '',
      prompt_custom: Object.keys(promptCustom).length
        ? JSON.stringify(promptCustom)
        : '',
      customily_options: Object.keys(mergedOptions).length
        ? JSON.stringify(mergedOptions)
        : '',
    }

    const imageTransferedLink = await customizationStore.transferImage(
      transferPayload
    )
    if (!imageTransferedLink) {
      throw new Error('Failed to transfer style')
    }

    const isReady = await waitForImageReady(imageTransferedLink)
    if (isReady) {
      imageUrlOutput.value = imageTransferedLink
      return imageTransferedLink
    } else {
      throw new Error('Image ready check timed out')
    }
  } catch (error: any) {
    Analytics.log('leversphere_ai_style_transfer_exception', {
      message: error?.message || error,
      product: productStore.product?.handle,
      templateId: templateIdSelected.value,
    })
    return ''
  }
}

/**
 * Xử lý sự kiện khi người dùng chọn và tải ảnh lên.
 * Thực hiện upload ảnh gốc, kích hoạt AI Style Transfer (nếu là chế độ AI), cập nhật canvas và lưu lịch sử.
 */
async function onImageUploadChange(event: Event, optName: string) {
  try {
    const input = event.target as HTMLInputElement
    if (!input.files) return
    const file = input.files[0]
    if (!file) return

    loadingAI.value = true
    uploadedFileName.value = file.name
    startUploadProgress()

    const payload = {
      file,
      id: templateIdSelected.value,
      isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
    }

    const uploadedUrl = await customizationStore.uploadImageTransferDefault(
      payload
    )

    imageUploadUrl.value = uploadedUrl

    let finalImageUrl = uploadedUrl
    let isCompletedOutput = false

    if (isStyleTransferMode.value) {
      if (mediaUploaderOptions.value.length <= 1) {
        // Chỉ có 1 media upload, tự động gọi API AI style transfer
        const { promptCustom, inputDetails } =
          updateCustomConfigFromPersonalization()
        finalImageUrl = await triggerAiStyleTransfer(
          uploadedUrl,
          promptCustom,
          inputDetails
        )
        imageUrlOutput.value = finalImageUrl
        isCompletedOutput = true
      } else {
        // TODO: Trường hợp có nhiều media upload, người dùng sẽ tự trigger bằng nút bấm riêng
      }
    }

    personalizationValues.value[optName] = uploadedUrl
    finishUploadProgress()

    const frame = activeTemplate.value?.layers?.find((l) => l.linkedOptionId === optName)
    if (frame || (isStyleTransferMode.value && isCompletedOutput)) {
      addOrUpdateImageLayer(frame?.id || 'canvas-background-layer', finalImageUrl, {
        left: frame?.left ?? 0,
        top: frame?.top ?? 0,
        width: frame?.width ?? fabricCanvas?.width ?? 1000,
        height: frame?.height ?? fabricCanvas?.height ?? 1000,
        angle: frame?.angle ?? 0,
        opacity: frame?.opacity ?? 1,
      })
    }

    const sortId = activeTemplate.value?.id || ''
    setAiStyleTransferRecently(finalImageUrl, uploadedUrl, sortId)
    aiStyleTransferRecentlyIndexSelected.value = 0

    step2Open.value = true

    productStore.hasPreview = true
    EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)
  } catch (error: any) {
    Analytics.log('leversphere_image_upload_exception', {
      message: error?.message || error,
      product: productStore.product?.handle,
      option: optName,
    })
  } finally {
    const input = event.target as HTMLInputElement
    if (input) {
      input.value = ''
    }
    loadingAI.value = false
  }
}

/**
 * Xóa ảnh đã tải lên khỏi state và canvas.
 */
function removeUploadedImage(optName: string) {
  try {
    personalizationValues.value[optName] = ''
    imageUploadUrl.value = ''
    imageUrlOutput.value = ''
    uploadedFileName.value = ''

    // if (fabricCanvas) {
    //   if (isStyleTransferMode.value) {
    //     fabricCanvas.setBackgroundImage('', () => {
    //       fabricCanvas?.renderAll()
    //       updateStandardPreviewImage()
    //     })
    //   } else {
    //     const existingImg = fabricCanvas
    //       .getObjects()
    //       .find(
    //         (obj: fabric.Object & { frameId?: string }) =>
    //           obj.frameId === optName
    //       )
    //     if (existingImg) {
    //       fabricCanvas.remove(existingImg)
    //       fabricCanvas.renderAll()
    //       updateStandardPreviewImage()
    //     }
    //   }
    // }
  } catch (error) {}
}





/**
 * Xuất dữ liệu canvas hiện tại ra dạng base64 và lưu làm ảnh preview sản phẩm.
 */
function updateStandardPreviewImage() {
  try {
    if (!fabricCanvas) return
    standardPreviewImage.value = fabricCanvas.toDataURL({ format: 'png' })
    productStore.productPreviewImage = standardPreviewImage.value
  } catch (error) {}
}

/**
 * Sắp xếp các đối tượng trên Fabric Canvas theo đúng thứ tự Z-Index định nghĩa trong templateConfig.
 */
function sortCanvasObjects() {
  try {
    if (!fabricCanvas || !activeTemplate.value) return

    const layers = activeTemplate.value.layers || []
    const objects = fabricCanvas.getObjects()

    objects.sort((a: any, b: any) => {
      const aIndex = layers.findIndex((l) => l.id === a.frameId)
      const bIndex = layers.findIndex((l) => l.id === b.frameId)
      return bIndex - aIndex
    })

    objects.forEach((obj, idx) => {
      fabricCanvas!.moveTo(obj, idx)
    })

    fabricCanvas.renderAll()
    updateStandardPreviewImage()
  } catch (error) {}
}

/**
 * Chèn hoặc cập nhật một layer Text lên Fabric canvas preview
 */
function addOrUpdateTextLayer(id: string, text: string, options: TextLayerOptions) {
  try {
    if (!fabricCanvas) return

    const existingText = fabricCanvas
      .getObjects()
      .find(
        (obj: fabric.Object & { frameId?: string }) => obj.frameId === id
      )

    if (existingText && existingText.type === 'text') {
      const textObj = existingText as fabric.Text
      textObj.set({
        text,
        left: options.left,
        top: options.top,
        fontSize: options.fontSize ?? 36,
        fontFamily: options.fontFamily ?? 'Arial',
        fontWeight: options.fontWeight ?? 'bold',
        fill: options.fill ?? '#ffffff',
        originX: options.originX ?? 'center',
        originY: options.originY ?? 'top',
        textAlign: options.textAlign ?? 'center',
        angle: options.angle ?? 0,
        opacity: options.opacity ?? 1,
      })
    } else {
      if (existingText) {
        fabricCanvas.remove(existingText)
      }
      const textObj = new fabric.Text(text, {
        left: options.left,
        top: options.top,
        fontSize: options.fontSize ?? 36,
        fontFamily: options.fontFamily ?? 'Arial',
        fontWeight: options.fontWeight ?? 'bold',
        fill: options.fill ?? '#ffffff',
        originX: options.originX ?? 'center',
        originY: options.originY ?? 'top',
        textAlign: options.textAlign ?? 'center',
        angle: options.angle ?? 0,
        opacity: options.opacity ?? 1,
        selectable: false,
        evented: false,
      })
      ;(textObj as fabric.Text & { frameId?: string }).frameId = id
      fabricCanvas.add(textObj)
    }
    sortCanvasObjects()
  } catch (error) {}
}

/**
 * Chèn hoặc cập nhật một layer Image lên Fabric canvas preview từ một URL ảnh
 */
function addOrUpdateImageLayer(id: string, imageUrl: string, options: ImageLayerOptions) {
  try {
    if (!fabricCanvas) return

    const existingImg = fabricCanvas
      .getObjects()
      .find(
        (obj: fabric.Object & { frameId?: string }) => obj.frameId === id
      )

    if (imageUrl) {
      fabric.Image.fromURL(
        imageUrl,
        (img: fabric.Image) => {
          if (existingImg) {
            fabricCanvas?.remove(existingImg)
          }
          img.set({
            left: options.left,
            top: options.top,
            scaleX: options.width / (img.width || 1),
            scaleY: options.height / (img.height || 1),
            angle: options.angle ?? 0,
            opacity: options.opacity ?? 1,
            selectable: false,
            evented: false,
          })
          ;(img as fabric.Image & { frameId?: string }).frameId = id
          fabricCanvas?.add(img)
          sortCanvasObjects()
        },
        { crossOrigin: 'anonymous' }
      )
    } else if (existingImg) {
      fabricCanvas.remove(existingImg)
      sortCanvasObjects()
    }
  } catch (error) {}
}


/**
 * Khởi tạo và cấu hình Fabric Canvas rỗng trên giao diện.
 */
function setupCanvas() {
  try {
    cleanupCanvas()

    const productPreviewSlide = document.getElementById(
      PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID
    )
    if (!productPreviewSlide || !activeTemplate.value) {
      return
    }

    const canvasWidth = activeTemplate.value.canvasSettings.width || 1000
    const canvasHeight = activeTemplate.value.canvasSettings.height || 1000

    const wrapper = document.createElement('div')
    wrapper.className = CUSTOMILY_CANVAS_WRAPPER_CLASS
    wrapper.style.width = '100%'
    wrapper.style.height = 'auto'
    wrapper.style.position = 'relative'

    const canvasEl = document.createElement('canvas')
    canvasEl.id = CUSTOMILY_PREVIEW_CANVAS_ID
    canvasEl.width = canvasWidth
    canvasEl.height = canvasHeight

    wrapper.appendChild(canvasEl)
    productPreviewSlide.appendChild(wrapper)
    productPreviewSlide.classList.add(
      PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS
    )

    fabricCanvas = new fabric.Canvas(canvasEl, {
      width: canvasWidth,
      height: canvasHeight,
      selection: false,
      hoverCursor: 'default',
      containerClass: CUSTOMILY_CANVAS_CONTAINER_CLASS,
    })
  } catch (error) {}
}

/**
 * Khởi tạo các layer (ảnh nền, text, image) của template và nạp lên Fabric Canvas.
 */
function initTemplateLayers() {
  try {
    if (!fabricCanvas || !activeTemplate.value) return

    let bgImgUrl = activeTemplate.value.canvasSettings.backgroundImageUrl

    if (bgImgUrl) {
      productStore.productPreviewImage = bgImgUrl
      fabric.Image.fromURL(
        bgImgUrl,
        (img: fabric.Image) => {
          img.set({
            originX: 'left',
            originY: 'top',
            scaleX: fabricCanvas!.width! / img.width!,
            scaleY: fabricCanvas!.height! / img.height!,
          })
          fabricCanvas!.setBackgroundImage(img, () => {
            fabricCanvas!.renderAll()
            updateStandardPreviewImage()
          })
        },
        { crossOrigin: 'anonymous' }
      )
    } else {
      fabricCanvas.renderAll()
      updateStandardPreviewImage()
    }

    if (activeTemplate.value.layers) {
      activeTemplate.value.layers.forEach((layer) => {
        const optionKey = layer.linkedOptionId || ''
        if (layer.type === 'text') {
          const textVal = personalizationValues.value[optionKey] || layer.textContent || ''
          addOrUpdateTextLayer(layer.id, textVal, {
            left: layer.left + layer.width / 2,
            top: layer.top,
            fontSize: (layer.style?.fontSize as number) ?? 36,
            fontFamily: (layer.style?.fontFamily as string) ?? 'Arial',
            fontWeight: (layer.style?.fontWeight as string) ?? 'bold',
            fill: (layer.style?.fill as string) ?? '#ffffff',
            originX: 'center',
            angle: layer.angle,
            opacity: layer.opacity,
          })
        } else if (layer.type === 'image') {
          let imgUrl = personalizationValues.value[optionKey] || ''
          if (!imgUrl && layer.imageOptions && layer.imageOptions.length > 0) {
            imgUrl = layer.imageOptions[0].src || ''
          }
          if (!imgUrl && layer.placeholderUrl) {
            imgUrl = layer.placeholderUrl || ''
          }
          addOrUpdateImageLayer(layer.id, imgUrl, {
            left: layer.left,
            top: layer.top,
            width: layer.width,
            height: layer.height,
            angle: layer.angle,
            opacity: layer.opacity,
          })
        }
      })
    }

    sortCanvasObjects()
    const hasCustomizedValues = Object.values(personalizationValues.value).some((val) => !!val)
    productStore.hasPreview = hasCustomizedValues
    EventBus.trigger(EVENT_PRODUCT_UPDATE_MAIN_SLIDER)
  } catch (error) {}
}

async function initCustomizer() {
  try {
    const code = templateCode.value

    // Khởi tạo personalizationValues từ route query sử dụng cấu hình tuỳ chọn của metafield
    const options = optionsConfig.value
    if (options.length > 0) {
      options.forEach((opt) => {
        const queryVal = (route.query[opt.name] ||
          route.query[opt.label]) as string
        if (queryVal) {
          personalizationValues.value[opt.name] = queryVal
        }
      })
    }

    await nextTick()
    setupCanvas()
    initTemplateLayers()
  } catch (error: any) {
    try {
      Analytics.log('leversphere_init_customizer_error', { message: error?.message || error })
    } catch (logError) {}
  }
}

/**
 * Hiển thị popup xem trước toàn màn hình và khởi tạo thư viện Panzoom để hỗ trợ kéo/thu phóng ảnh.
 */
async function showPreviewPopup() {
  try {
    Analytics.track('Preview clicked')
    if (fabricCanvas) {
      productStore.productPreviewImage = fabricCanvas.toDataURL({
        format: 'png',
      })
    }
    previewPopup.value?.show()

    requestAnimationFrame(() => {
      const previewEl = document.createElement('img')
      previewEl.id = 'leversphere-preview-image'
      previewEl.src = productStore.productPreviewImage || ''

      if (!popupCanvasWrapper.value) return

      if (isProductHasTags(productStore.product, ['watermark', 'leversphere_watermark'])) {
        if (typeof window !== 'undefined') {
          if (!document.documentElement.style.getPropertyValue('--customily-watermark-image')) {
            const domain = window.location.hostname || window.location.host || 'hopesify.com'
            const capitalizedDomain = domain.charAt(0).toUpperCase() + domain.slice(1)
            const encodedDomain = encodeURIComponent(capitalizedDomain)
            const svg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Cstyle%3Etext %7B font-size: 22px; font-weight: bold; font-family: Arial, sans-serif; fill: rgba(0,0,0,0.13); text-anchor: middle; %7D%3C/style%3E%3Ctext transform='translate(75, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(225, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(150, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(0, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(300, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3C/svg%3E")`
            document.documentElement.style.setProperty('--customily-watermark-image', svg)
          }
        }
        popupCanvasWrapper.value.classList.add('has-watermark')
      }

      const panZoomViewport = popupCanvasWrapper.value.querySelector(
        '.panzoom__viewport'
      ) as HTMLElement
      if (!panZoomViewport) return

      panZoomViewport.innerHTML = ''

      const wrapperWidth = popupCanvasWrapper.value.clientWidth
      const maxWidth = Math.min(wrapperWidth, document.body.clientWidth * 0.95)
      const maxHeight = Math.min(
        wrapperWidth,
        document.body.clientHeight * 0.85
      )
      const width = Math.min(maxWidth, maxHeight)

      previewEl.style.width = width + 'px'
      previewEl.style.height = 'auto'
      previewEl.style.maxWidth = 'none'
      previewEl.style.maxHeight = 'none'
      popupCanvasWrapper.value.style.width = width + 'px'
      popupCanvasWrapper.value.style.height = width + 'px'
      popupCanvasWrapper.value.style.margin = '0 auto'

      panZoomViewport.appendChild(previewEl)
      requestAnimationFrame(async () => {
        if (!Panzoom) {
          Panzoom = (await import('@fancyapps/ui')).Panzoom
        }
        previewEl.classList.add('panzoom__content')
        panzoomInstance = new Panzoom(popupCanvasWrapper.value, {
          width: width,
          height: width,
          panOnly: true,
          click: false,
          doubleClick: false,
          wheel: false,
          pinchToZoom: false,
        })
      })
    })
  } catch (error) {}
}

/**
 * Đóng popup xem trước và hủy đối tượng Panzoom để tránh rò rỉ bộ nhớ.
 */
function closePreviewPopup() {
  try {
    if (panzoomInstance) {
      panzoomInstance.destroy()
      panzoomInstance = null
    }
    const previewImg = document.getElementById('leversphere-preview-image')
    if (previewImg) {
      previewImg.remove()
    }
  } catch (error) {}
}

/**
 * Bấm nút "Add To Cart" từ popup preview: kích hoạt emit sự kiện thêm vào giỏ hàng và đóng popup.
 */
function clickAddToCartOnPreview() {
  try {
    emit('add-to-cart')
    previewPopup.value?.close()
    EventBus.trigger(EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW)
  } catch (error) {}
}

// Các hàm của chế độ AI Style Transfer
/**
 * Khởi tạo cấu hình và template cho chế độ AI Style Transfer bằng cách gọi API từ Storefront.
 */
async function initStyleTransfer() {
  // Logic lấy cấu hình AI từ API đã được comment lại để hợp nhất vào metadata của customizerSchema.
  /*
  try {
    const product = productStore.product
    if (!product) return

    let codePromptAI
    if (isProductHasTags(product, ['AI_removebg', 'AI_QRMusic', 'AI_Music'])) {
      const config =
        settingStore.baseProductPage?.productOptionsAISettings?.find(
          (item: any) => item.handle == product.handle
        )
      if (config && config?.options?.length) {
        codePromptAI = config?.options[0]?.template
      }
    }

    const payload = {
      code: codePromptAI
        ? `${extractProductSKUFromHandle(product.handle)}_${codePromptAI}`
        : extractProductSKUFromHandle(product.handle),
      type: product.productType || '',
      tag: product.tags?.join('|') || '',
      isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
    }

    const templates = await customizationStore.fetchCustomizationTemplates(
      payload
    )

    if (templates && templates.length > 0) {
      customizationTemplate.value = templates[0]

      if (templates[0].templates?.length > 0) {
        const templateIdOriginal = '0000'
        const index = templates[0].templates.findIndex(
          (option: any) => option.template_id === templateIdOriginal
        )
        templateIdSelected.value =
          index > -1
            ? templateIdOriginal
            : templates[0].templates[0].template_id
      }
    }
  } catch (error) {}
  */
}

/**
 * Lấy lịch sử các ảnh AI Style Transfer đã tạo gần đây lưu trong cache (lọc trong vòng 7 ngày).
 */
async function getAiStyleTransferRecently() {
  try {
    const productHandle = productStore.product?.handle
    if (!productHandle) return []
    const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
    const cacheResponse = await CacheService.instance?.get(cacheKey)
    const aiStyleTransferRecentlyFromCache =
      getJSONfromCacheResponse(cacheResponse)
    if (aiStyleTransferRecentlyFromCache) {
      const now = Date.now()
      const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000
      aiStyleTransferRecently.value = aiStyleTransferRecentlyFromCache.filter(
        (item: { createdAt: number }) => {
          const itemTime = new Date(item.createdAt).getTime()
          return itemTime >= sevenDaysAgo && itemTime <= now
        }
      )
      if (
        aiStyleTransferRecently.value.length !==
        aiStyleTransferRecentlyFromCache.length
      ) {
        await CacheService.instance?.delete(cacheKey)
        CacheService.instance?.set(
          cacheKey,
          cloneDeep(aiStyleTransferRecently.value),
          SEVEN_DAYS_IN_MILLISECONDS
        )
      }
      return aiStyleTransferRecently.value
    }
    return []
  } catch (error) {
    return []
  }
}

/**
 * Lưu ảnh AI mới tạo thành công vào cache lịch sử của trình duyệt.
 */
async function setAiStyleTransferRecently(
  image: string,
  imageUploadUrl: string,
  option_sort_id?: string
) {
  try {
    const productHandle = productStore.product?.handle
    if (!productHandle) return
    const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
    const cacheResponse = await CacheService.instance?.get(cacheKey)
    const aiStyleTransferRecentlyFromCache =
      getJSONfromCacheResponse(cacheResponse)
    await CacheService.instance?.delete(cacheKey)

    if (aiStyleTransferRecentlyFromCache?.length) {
      const now = Date.now()
      const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000
      aiStyleTransferRecently.value = aiStyleTransferRecentlyFromCache.filter(
        (item: { createdAt: number }) => {
          const itemTime = new Date(item.createdAt).getTime()
          return itemTime >= sevenDaysAgo && itemTime <= now
        }
      )
    }

    aiStyleTransferRecently.value = [
      {
        image,
        createdAt: Date.now(),
        imageUploadUrl,
        option_sort_id: option_sort_id || '',
      },
      ...(aiStyleTransferRecently.value || []),
    ]
    CacheService.instance?.set(
      cacheKey,
      cloneDeep(aiStyleTransferRecently.value),
      SEVEN_DAYS_IN_MILLISECONDS
    )
  } catch (error) {}
}

/**
 * Tính số mili-giây còn lại từ thời điểm hiện tại cho đến cuối ngày (23:59:59).
 */
function getMillisecondsUntilEndOfDay() {
  try {
    const now = new Date()
    const endOfDay = new Date(now)
    endOfDay.setHours(23, 59, 59, 999)
    return endOfDay.getTime() - now.getTime()
  } catch (error) {
    return 0
  }
}

/**
 * Thiết lập số lượt preview AI miễn phí mặc định trong ngày (10 lượt) vào cache nếu chưa tồn tại.
 */
async function setDefaultAiStyleTransferLimited() {
  try {
    const productHandle = productStore.product?.handle
    if (!productHandle) return
    const cacheKey = `${AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX}_${productHandle}`
    const cacheResponse = await CacheService.instance?.get(cacheKey)
    const aiTransferLimitedFromCache = getJSONfromCacheResponse(cacheResponse)
    if (!aiTransferLimitedFromCache) {
      const ttl = getMillisecondsUntilEndOfDay()
      CacheService.instance?.set(cacheKey, transferLimited, ttl)
    }
  } catch (error) {}
}

/**
 * Áp dụng một ảnh AI cũ từ danh sách lịch sử khi người dùng click chọn.
 */
async function chooseImageAiStyleTransferRecently(index: number) {
  try {
    aiStyleTransferRecentlyIndexSelected.value = index
    const item = filteredHistory.value[index]
    if (!item) return

    imageUploadUrl.value = item.imageUploadUrl
    imageUrlOutput.value = item.image
    productStore.productPreviewImage = item.image

    isSuccessUploadAI.value = true
    const mediaOpt = mediaUploaderOptions.value[0]
    if (mediaOpt) {
      personalizationValues.value[mediaOpt.name] = item.imageUploadUrl
    }
    if (mediaOpt) {
      const frame = activeTemplate.value?.layers?.find(
        (l) => l.linkedOptionId === mediaOpt.name || l.id === mediaOpt.name
      )
      if (frame || isStyleTransferMode.value) {
        addOrUpdateImageLayer(frame?.id || 'canvas-background-layer', item.image, {
          left: frame?.left ?? 0,
          top: frame?.top ?? 0,
          width: frame?.width ?? fabricCanvas?.width ?? 1000,
          height: frame?.height ?? fabricCanvas?.height ?? 1000,
          angle: frame?.angle ?? 0,
          opacity: frame?.opacity ?? 1,
        })
      }
    }

    step2Open.value = true

    productStore.hasPreview = true
    EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)
  } catch (error) {}
}

/**
 * Polling liên tục kiểm tra xem ảnh đã được AI xử lý xong và tải thành công lên Cloud chưa.
 */
async function waitForImageReady(
  url: string,
  interval = 10000,
  maxAttempts = 60
) {
  try {
    for (let i = 1; i <= maxAttempts; i++) {
      const isReady = await new Promise<boolean>((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now()
      })
      if (isReady) return true
      if (i < maxAttempts) {
        await new Promise((r) => setTimeout(r, interval))
      }
    }
    return false
  } catch (error) {
    return false
  }
}

const transferLimited = 10

let uploadProgressInterval: any = null

/**
 * Bắt đầu chạy hiệu ứng thanh tiến trình (progress bar) giả lập khi đang xử lý upload/AI.
 */
function startUploadProgress() {
  try {
    uploadProgress.value = 0
    if (uploadProgressInterval) clearInterval(uploadProgressInterval)
    uploadProgressInterval = setInterval(() => {
      if (uploadProgress.value < 98) {
        const step = 1.63 + (Math.random() * 0.4 - 0.2)
        uploadProgress.value = Math.min(
          98,
          Math.round((uploadProgress.value + step) * 10) / 10
        )
      } else if (uploadProgress.value < 99) {
        uploadProgress.value = 99
      }
    }, 1000)
  } catch (error) {}
}

/**
 * Kết thúc hiệu ứng thanh tiến trình (set về 100%) và xóa interval.
 */
function finishUploadProgress() {
  try {
    if (uploadProgressInterval) {
      clearInterval(uploadProgressInterval)
      uploadProgressInterval = null
    }
    uploadProgress.value = 100
  } catch (error) {}
}

/**
 * Khớp các thuộc tính personalization đã nhập với các trường cấu hình để chuẩn bị dữ liệu gửi đi API AI.
 */
function updateCustomConfigFromPersonalization() {
  try {
    const promptCustom: Record<string, string> = {}
    const inputDetails: Record<string, string> = {}

    optionsConfig.value.forEach((opt: any) => {
      if (opt.customPromptKey) {
        const val = personalizationValues.value[opt.name] || ''
        const label = opt.label || ''
        
        promptCustom[opt.customPromptKey] = val
        inputDetails[label] = val
      }
    })

    return { promptCustom, inputDetails }
  } catch (error) {
    return { promptCustom: {}, inputDetails: {} }
  }
}

/**
 * Thu thập và đóng gói dữ liệu cá nhân hóa (base64 canvas, URL chia sẻ) để gửi lên giỏ hàng / checkout.
 */
function getPersonalizationDetails() {
  try {
    const origin = settingStore.shop?.domain
      ? `https://${settingStore.shop.domain}`
      : ''
    const pathname = route.path

    if (isStyleTransferMode.value) {
      const { inputDetails } = updateCustomConfigFromPersonalization()

      // Xây dựng URL tùy chỉnh với các tham số
      const params = new URLSearchParams()
      if (productStore.selectedVariant?.id) {
        params.set(
          'variant',
          getRawIdFromShopifyId(productStore.selectedVariant.id)
        )
      }
      optionsConfig.value.forEach((opt: any) => {
        const val = personalizationValues.value[opt.name] || ''
        if (val) {
          params.set(opt.name, val)
        }
      })
      if (imageUploadUrl.value) {
        params.set('imageUploadUrl', imageUploadUrl.value)
      }
      if (imageUrlOutput.value) {
        params.set('imageOutputUrl', imageUrlOutput.value)
      }
      const customizationUrl = `${origin}${pathname}?${params
        .toString()
        .replace(/\+/g, '%20')}`

      let base64 = ''
      if (fabricCanvas) {
        base64 = fabricCanvas.toDataURL({ format: 'png' })
      }

      return {
        isStyleTransfer: true,
        imageOutputUrl: '',
        imageUploadUrl: imageUploadUrl.value,
        inputDetails: Object.keys(inputDetails).length
          ? JSON.stringify(inputDetails)
          : '',
        customizationUrl,
        base64,
      }
    }

    let base64 = ''
    if (fabricCanvas) {
      base64 = fabricCanvas.toDataURL({ format: 'png' })
    }

    const params = new URLSearchParams()
    if (productStore.selectedVariant?.id) {
      params.set(
        'variant',
        getRawIdFromShopifyId(productStore.selectedVariant.id)
      )
    }
    optionsConfig.value.forEach((opt: any) => {
      const val = personalizationValues.value[opt.name] || ''
      if (val) {
        params.set(opt.name, val)
      }
    })

    const customizationUrl = `${origin}${pathname}?${params
      .toString()
      .replace(/\+/g, '%20')}`

    return {
      base64,
      customizationUrl,
    }
  } catch (error) {
    return {}
  }
}

function validate(): boolean {
  validationErrors.value = {}
  let isValid = true
  let firstInvalidOptName = ''

  const options = optionsConfig.value || []
  for (let i = 0; i < options.length; i++) {
    const opt = options[i]
    if (opt.required) {
      const val = personalizationValues.value[opt.name]
      if (!val || !val.trim()) {
        isValid = false
        const cleanLabel = opt.label ? opt.label.replace('*', '').trim() : 'This field'
        const errorMessage = `${cleanLabel} is required`
        validationErrors.value[opt.name] = errorMessage

        if (!firstInvalidOptName) {
          firstInvalidOptName = opt.name

          try {
            Analytics.track('errors', {
              message: errorMessage,
            })
          } catch (e) {
            console.log(e)
          }
        }
      }
    }
  }

  if (!isValid) {
    nextTick(() => {
      const wrapper = document.querySelector('.leversphere-options-wrapper')
      if (wrapper && firstInvalidOptName) {
        const inputOrElem = wrapper.querySelector(`[name="properties[${firstInvalidOptName}]"], [attributeKey="${firstInvalidOptName}"], input, textarea, select, .sib-file-select`) as HTMLElement
        const targetElem = inputOrElem || wrapper
        targetElem.scrollIntoView({ behavior: 'smooth', block: 'center' })
        if (typeof targetElem.focus === 'function') {
          targetElem.focus()
        }
      }
    })
    return false
  }

  return true
}

defineExpose({
  getPersonalizationDetails,
  validate,
})

let unwatchTemplateCode: (() => void) | null = null
let unwatchProductId: (() => void) | null = null

onMounted(async () => {
  unwatchTemplateCode = watch(
    () => templateCode.value,
    (newCode) => {
      if (newCode) {
        initCustomizer()
      }
    },
    { immediate: true }
  )

  unwatchProductId = watch(
    () => productStore.product?.id,
    (id) => {
      if (id) {
        productStore.numberOfPersonalizedProductVisited++
      }
    },
    { immediate: true }
  )

  if (isStyleTransferMode.value) {
    await initStyleTransfer()
    setDefaultAiStyleTransferLimited()
    getAiStyleTransferRecently()
  }
})

onUnmounted(() => {
  if (unwatchTemplateCode) unwatchTemplateCode()
  if (unwatchProductId) unwatchProductId()
  cleanupCanvas()
  if (panzoomInstance) {
    panzoomInstance.destroy()
  }

  if (uploadProgressInterval) {
    clearInterval(uploadProgressInterval)
  }

  try {
    debounceMap.forEach((timeout) => clearTimeout(timeout))
    debounceMap.clear()
  } catch (e) {
    console.log(e)
  }
})
</script>

<style lang="scss" scoped>
.product__option-new-ui {
  border: none;
  padding: 0;
  background: transparent;

  > h2 {
    display: none;
  }

  #leversphere-options {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  .first-step {
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 8px 8px 0 0;

    .step-body {
      padding-top: 6px;
    }
  }

  .leversphere-options-wrapper {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .sib-form-item {
      margin-bottom: 0;

      label,
      .sib-form-item__label {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #000;
        margin-bottom: 6px;
      }
    }

    input[type='text'],
    .sib-input {
      height: 32px;
      border-radius: 5px;
      border-width: 1px 1px 2px 1px;
      border-style: solid;
      border-color: #000;
      background-color: #fff;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 16px;
      letter-spacing: 0;
      outline: none;
      width: 100%;
      padding: 6px 10px;

      &:focus,
      &:active {
        background-color: #ebf6eb;
      }

      &::placeholder {
        color: #999;
        font-weight: 400;
      }
    }

    .sib-select,
    select {
      min-height: 32px;
      border-radius: 5px;
      border-width: 1px 1px 2px 1px;
      border-style: solid;
      border-color: #000;
      background-color: #fff;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .customization-upload-image-upload-title,
  .ai-style-transfer-history-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #000;
    margin-bottom: 6px;
  }

  .customization-style-transfer-upload-image-button-wrap {
    min-height: 106px;
    border: 1px dashed #000;
    border-radius: 8px;
    padding: 22px 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    &::before {
      content: '';
      width: 22px;
      height: 22px;
      border-radius: 4px;
      background-color: #cb6222;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='14' viewBox='0 0 36 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M32.4 3.75H26.1L23.22 0H12.78L9.9 3.75H3.6C1.62 3.75 0 5.4375 0 7.5V26.25C0 28.3125 1.62 30 3.6 30H32.4C34.38 30 36 28.3125 36 26.25V7.5C36 5.4375 34.38 3.75 32.4 3.75ZM18 25C13.86 25 10.5 21.5 10.5 17.1875C10.5 12.875 13.86 9.375 18 9.375C22.14 9.375 25.5 12.875 25.5 17.1875C25.5 21.5 22.14 25 18 25ZM18 11.875C15.12 11.875 12.78 14.25 12.78 17.1875C12.78 20.125 15.12 22.5 18 22.5C20.88 22.5 23.22 20.125 23.22 17.1875C23.22 14.25 20.88 11.875 18 11.875Z' fill='white'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 16px 14px;
    }
  }

  .sib-file-select--role-default,
  .sib-button,
  .btn {
    border: 1px solid #734c29;
    border-radius: 8px;
    padding: 8px 20px;
    min-height: 28px;
    font-size: 9px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    text-transform: none;
    letter-spacing: 0.3px;
    background: #fff;
    color: #000;
  }

  .style-transfer-image-preview {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    object-fit: cover;
    background: #f3ebe1;
  }

  .help-text {
    font-size: 8px;
    line-height: 1.4;
    color: #444;
    margin-top: 8px;
    display: block;
  }

  .tooltip-image-processing,
  .customization-upload-image-wrapper-message,
  .rate-limit-transfer-message {
    font-size: 13px;
    line-height: 1.4;
    color: #757a76;
    margin-top: 8px;
  }

  .remove-custom-upload-image {
    color: #757a76;
    font-weight: 700;
    cursor: pointer;
    padding: 8px 12px;
  }

  .music-action-button,
  .generate-button {
    width: 100%;
    min-height: 60px;
    max-width: 100%;
    justify-content: center;
  }

  .music-progress-bar {
    width: 100%;
    height: 13px;
    background: #d9d9d9;
    border-radius: 5px;
    overflow: hidden;
  }

  .music-progress-fill {
    height: 100%;
    background: #5d8c16;
    transition: width 0.3s ease;
  }

  .music-progress-text {
    text-align: center;
    margin-top: 8px;
    font-size: 13px;
    color: #757a76;
  }

  .step-item {
    border-left: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    box-shadow: none;

    &--open {
      .step-header__toggle {
        transform: rotate(180deg);
      }
    }
  }

  .leversphere-review-step {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .leversphere-review-step.has-no-step3 {
    border-bottom: 1px solid #e9e9e9;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    overflow: hidden;
  }

  .step-header {
    background: transparent;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    user-select: none;
  }

  .step-header__title {
    display: flex;
    align-items: center;
    gap: 12px;

    h2 {
      margin: 0;
      font-size: 16px;
      font-weight: 700;
      color: #000;
      letter-spacing: 0.3px;
      text-transform: uppercase;
    }
  }

  .step-header__icon {
    color: #cb6222;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &--orange {
      width: 20px;
      height: 22px;
      background-color: #cb6222;
      color: #fff;
      border-radius: 3px;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .step-header__toggle {
    transition: transform 0.3s ease;
    color: #000;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .step-body {
    padding: 20px;
  }

  .artwork-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .artwork-preview__box {
    aspect-ratio: 1;
    border: 2px solid #000;
    background-color: #eee;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .artwork-preview__empty {
    padding: 16px;
    color: #757a76;
    font-size: 16px;
    text-align: center;
  }

  .checkerboard {
    background-image: linear-gradient(45deg, #ddd 25%, transparent 25%),
      linear-gradient(-45deg, #ddd 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #ddd 75%),
      linear-gradient(-45deg, transparent 75%, #ddd 75%);
    background-size: 50px 50px;
    background-position: 0 0, 0 25px, 25px -25px, -25px 0px;
  }

  .artwork-preview .btn--secondary {
    height: 36px;
    max-width: 100%;
    border: 1px solid #bf5b04;
    border-radius: 8px;
    background: #fff;
    font-size: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .ai-style-transfer-recently {
    display: flex;
    overflow-x: auto;
    gap: 9px;
    padding: 4px;
    max-width: 100%;
  }

  .ai-style-transfer-recently__item {
    position: relative;
    flex: 0 0 64px;
    width: 64px;
    height: 64px;
    border-radius: 16px;
    overflow: hidden;
    background: #eae2d7;
    border: 8px solid transparent;
    box-shadow: none;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 4px;
      box-sizing: border-box;
    }
  }

  .ai-style-transfer-recently__item--active::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 4px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #5d8c16;
    border: 2px solid #fff;
  }

  #leversphere-options {
    .ai-style-transfer-history-title,
    .ai-style-transfer-recently {
      display: none;
    }
  }

  .step-item {
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-bottom: none;
    border-radius: 0;
  }

  .first-step {
    border-radius: 12px 12px 0 0;
  }

  .leversphere-review-step,
  .last-step {
    border-radius: 0;
  }

  .last-step {
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0 0 12px 12px;
  }

  .leversphere-review-step.has-no-step3 {
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0 0 12px 12px;
    overflow: hidden;
  }

  .step-header {
    padding: 28px 24px;
  }

  .step-header__title {
    gap: 14px;

    h2 {
      font-size: 26px;
      line-height: 32px;
      letter-spacing: 0;
    }
  }

  .step-header__icon {
    width: 40px;
    height: 44px;

    svg {
      width: 40px;
      height: 40px;
    }

    &--orange {
      width: 40px;
      height: 44px;
      border-radius: 5px;

      svg {
        width: 40px;
        height: 40px;
      }
    }
  }

  .step-body,
  .step-body-v3 {
    padding: 6px 28px 28px;
  }

  .leversphere-options-wrapper {
    gap: 22px;

    .sib-form-item {
      label,
      .sib-form-item__label {
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 10px;
      }
    }

    input[type='text'],
    .sib-input {
      height: 60px;
      border-width: 1px 2px 2px 1px;
      font-size: 26px;
      padding: 12px 16px;
    }
  }

  .customization-upload-image-upload-title {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 10px;
  }

  .customization-style-transfer-upload-image-button-wrap {
    min-height: 207px;
    border: 2px dashed #000;
    padding: 38px 24px;
    gap: 22px;

    &::before {
      width: 48px;
      height: 48px;
      border-radius: 0;
      background-color: transparent;
      background-image: url("data:image/svg+xml,%3Csvg width='48' height='40' viewBox='0 0 36 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M32.4 3.75H26.1L23.22 0H12.78L9.9 3.75H3.6C1.62 3.75 0 5.4375 0 7.5V26.25C0 28.3125 1.62 30 3.6 30H32.4C34.38 30 36 28.3125 36 26.25V7.5C36 5.4375 34.38 3.75 32.4 3.75ZM18 25C13.86 25 10.5 21.5 10.5 17.1875C10.5 12.875 13.86 9.375 18 9.375C22.14 9.375 25.5 12.875 25.5 17.1875C25.5 21.5 22.14 25 18 25ZM18 11.875C15.12 11.875 12.78 14.25 12.78 17.1875C12.78 20.125 15.12 22.5 18 22.5C20.88 22.5 23.22 20.125 23.22 17.1875C23.22 14.25 20.88 11.875 18 11.875Z' fill='%23cb6222'/%3E%3C/svg%3E");
      background-size: 48px 40px;
    }

    .sib-file-select--role-default {
      width: 208px;
      height: 50px;
      min-height: 50px;
      border: 1px solid #734c29;
      border-radius: 16px;
      font-size: 14px !important;
      letter-spacing: 0.6px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
    }
  }

  .first-step .help-text {
    display: none;
  }

  .custom-upload-card {
    min-height: 88px;
    padding: 12px;
    background: #fff;
    border-radius: 5px;
    border-width: 1px 2px 2px 1px;
    border-style: solid;
    border-color: #000;
    display: flex;
    align-items: center;
    gap: 50px;
    box-sizing: border-box;
    width: 100%;

    &.is-complete {
      background: #ebf6eb;
    }

    &__thumb {
      position: relative;
      flex-shrink: 0;
    }

    .thumb-container {
      width: 64px;
      height: 64px;
      border-radius: 16px;
      border: 1px solid #e5e7eb;
      background: #f3ebe1;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .thumb-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d1cec9;
    }

    .check-badge {
      position: absolute;
      top: -6px;
      right: -8px;
    }

    &__info {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
      min-width: 0;
    }

    .status-text {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: #24292e;
      margin-bottom: 4px;
    }

    .filename-text {
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .progress-bar {
      max-width: 100%;
      height: 13px;
      background: #d9d9d9;
      border-radius: 5px;
      margin-top: 4px;
      overflow: hidden;
    }

    .progress-fill {
      height: 100%;
      background: #5d8c16;
      transition: width 0.3s ease;
    }

    .delete-action {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 4px;
      margin-left: auto;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .artwork-preview {
    gap: 28px;
  }

  .artwork-preview__box {
    border-width: 2px;
  }

  .artwork-preview .btn--secondary {
    height: 54px;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .nested-step {
    width: 100%;
    margin-top: -4px;

    &__header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      cursor: pointer;
      font-size: 18px;
      line-height: 24px;
      color: #000;
    }

    &__toggle {
      display: flex;
      align-items: center;
      transition: transform 0.3s ease;
    }

    &--open {
      .nested-step__toggle {
        transform: rotate(180deg);
      }
    }

    &__body {
      margin-top: 14px;
    }

    .label-v3 {
      display: block;
      font-size: 20px;
      line-height: 26px;
      color: #757a76;
      margin-bottom: 8px;
    }
  }

  .textarea-field {
    width: 100%;
    min-height: 124px;
    border: 1px solid #000;
    border-radius: 4px;
    background: #fff;
    font-size: 18px;
    padding: 10px;
    box-sizing: border-box;
  }

  .step-body-v3 {
    gap: 48px;
  }

  .label-v3 {
    font-size: 24px;
    line-height: 28px;
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: all 0.3s ease-in-out;
    max-height: 1000px;
    overflow: hidden;
    opacity: 1;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    max-height: 0;
    opacity: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  .customily-preview {
    display: none;
  }
}

.leversphere-options-wrapper {
  background-color: var(--background-color);
  border: solid 1px var(--border-color);
  border-radius: var(--border-radius-small);
  padding: 1.5em;
  margin-bottom: 1em;

  .sib-form-item {
    margin-bottom: 1.2em;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.canvas-wrapper {
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  &.leversphere-ai-preview-wrapper {
    aspect-ratio: unset;
    height: auto;
  }
  .canvas-container {
    width: 100% !important;
    height: 100% !important;
    margin: 0 auto;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.customization-style-transfer-upload-image-button-wrap {
  display: flex;
  align-items: center;
  .sib-file-select-wrapper {
    width: auto;
  }
  .style-transfer-image-preview {
    margin-left: 8px;
    width: 42px;
    height: 42px;
    object-fit: contain;
    border: 1px solid #d5d5d5;
  }
}

.ai-style-transfer-recently {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  max-width: 320px;
  margin-bottom: 6px;

  &::-webkit-scrollbar-track {
    background-color: var(--background-color);
  }

  &::-webkit-scrollbar {
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b4b4b4;
    border-radius: 1rem;
  }

  &__item {
    background-color: transparent;
    box-sizing: border-box;
    box-shadow: 0 0 2px 1px #0003;
    border: 3px solid #fff;
    width: 62px;
    height: 62px;
    transition: all 0.3s ease;
    cursor: pointer;
    margin: 5px 5px 3px 4px;

    img {
      width: 56px;
      height: 56px;
      object-fit: contain;
    }
  }
}

.ai-style-transfer-history-title {
  font-weight: 600;
  margin: 14px 0 2px 0;
}

.rate-limit-transfer-message {
  font-size: 12px;
  color: var(--color-secondary);
  margin-top: 8px;
  margin-bottom: 8px;
}

.remove-custom-upload-image {
  padding: 14px;
}

.generate-loading {
  --loading-size: 16px;
  --loading-line-width: 2px;
  color: #ffffff;
  transform: translateX(-6px);
}

.generate-button {
  max-width: 170px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.disable-button {
  pointer-events: none;
}

.product-popup-review__canvas-wrapper {
  align-items: center;

  .panzoom__viewport {
    position: relative;
  }
}

#product-popup-review {
  .is-close {
    top: 12px !important;      
    right: 9px !important;   
  }
}
</style>
